/*
    Business logic menu data added during development
    roles: 0: Registered user:, 1:administrators, 9:Menu for login page display only
*/
import Layout from "@/layout";
import home from "./home.js"
import whitelistChangeProposal from "./whitelistChangeProposal.js"
const menuRoutes = [
  // {
  //   path: "/whitelistChangeProposal",
  //   alwaysShow: false,
  //   name: "WhitelistChangeProposal",
  //   redirect: "noRedirect",
  //   component: Layout,
  //   meta: {
  //     title: "Whitelist Change Proposal",
  //   },
  //   children: [...whitelistChangeProposal],
  // },
  
];
export default menuRoutes;
